import React, { useState, useEffect } from 'react'
import { motion } from "framer-motion"
import "./About.scss"
import { images } from '../../constants'
import { AppWrap } from '../../wrapper';
import { urlFor, client  } from '../../client'

const About = () => {
  const [abouts, setAbouts] = useState([])

  useEffect(() => {
    const query = '*[_type == "abouts"]'
  
    client.fetch(query)
    .then((data)=>{
      setAbouts(data)
    })
  }, [])

  return (
    <>
      <h2 className='head-text'>
      I am a
      <span style={{marginLeft:10, marginRight:10}}>
      Software Engineer
      </span>
      Who Spends Way To Much Time Thinking About 
      <span style={{marginLeft:10, marginRight:10}}>
      Football</span>
      </h2>

      <h2  className='subheader subheader-text'>
      I do a lot of things! I'm a senior software engineer with experience developing large scale cloud applications in both corporate and start-up environments! Additionally, I'm a content creator producing English and German football content. When I’m not creating, I’m either cooking, involved in local urbanism, reading another football book or deep into a football analytics project.
      <br/>
      <br/>
      Some of those projects end up here! This is where you can find everything I'm working on in the world of Football!
      </h2>

    </>
  )
}

export default AppWrap(About, 'about');